(function storeAnalytics() {
  const API_URL = 'https://parkave-rebate-engine.vercel.app/api/store-analytics';
  const ATTR = 'data-store-analytics';

  function track(title) {
    if (!title) return;

    const body = JSON.stringify({ title });

    fetch(API_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body,
      keepalive: true,
      mode: 'cors',
      credentials: 'omit',
      priority: 'low'
    }).catch(() => {});
  }

  document.addEventListener('click', (event) => {
    const el = event.target.closest(`[${ATTR}]`);
    if (!el) return;
    track(el.getAttribute(ATTR));
  }, true);

  window.theme = window.theme || {};
  window.theme.trackStoreAnalytics = track;
})();
